import * as Actions from './type';
import {
  createInvoiceApi,
  getInvoiceApi,
  getInvoicesApi,
} from '../../api/invoice/invoice-api';

export const createInvoice = async (roId) => {
  try {
    await createInvoiceApi(roId);
  } catch (error) {
    console.log('Error while creating Invoice!');
  }
};

export const getInvoice = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_INVOICE_REQUEST,
    });
    const { data } = await getInvoiceApi(id);
    dispatch({
      type: Actions.GET_INVOICE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_INVOICE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getInvoices = (query = false) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_INVOICES_REQUEST,
    });
    const { data } = await getInvoicesApi(query);
    dispatch({
      type: Actions.GET_INVOICES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_INVOICES_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const clearGetInvoiceState = () => (dispatch) => {
  dispatch({
    type: Actions.CLEAR_GET_INVOICE_STATE,
  });
};
